import { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { EdgelessFocusMaskManager } from '@/plugins/apps/ai-agent/edgeless-focus-mask';
import type { ContextMenuPlugin } from '@/plugins/context-menu';
import { useFusionImageState } from '../state';

export const useFusionImageInit = () => {
    const identity = useIdentity();
    const framework = getFramework(identity);
    const originLayers = useFusionImageState()((state) => state.originLayers);

    // 控制隐藏、显示素材层
    useEffect(() => {
        if (!originLayers || originLayers.length === 0) return;

        // 禁用图层选中事件，取消激活图层
        framework.service.editor.setDisableMouseSelect(true);
        // 取消 hover 态，进入时禁用 hover
        framework.service.editor.setDisableHover(true);
        framework.service.frame.setHoverId('');
        // 需要控制 focus 后的画布缩放，保证菜单可见
        framework.service.registration.getInstance<EdgelessFocusMaskManager>('EdgelessFocusMask').focus(
            originLayers.map((layer) => layer.id),
            { blindAreas: { bottom: 164 + 16 } },
        );
        // 使用原始的图片渲染地址，比如不带有水印的图片地址
        originLayers.forEach((layer) => {
            // 移除 ai 水印
            framework.service.edgelessCanvas.getByLayerId(layer.id)?.setAiWatermark(false);
        });
        framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin').disableMenu();

        return () => {
            if (!originLayers || originLayers.length === 0) return;

            framework.service.registration.getInstance<EdgelessFocusMaskManager>('EdgelessFocusMask').exit();
            // 恢复图层选中事件
            framework.service.editor.setDisableMouseSelect(false);
            // 恢复 hover 态
            framework.service.editor.setDisableHover(false);
            // 恢复使用自定义的图片渲染地址，比如带有水印的图片地址
            originLayers.forEach((layer) => {
                // 恢复 ai 水印
                framework.service.edgelessCanvas.getByLayerId(layer.id)?.setAiWatermark(true);
            });
            framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin').enableMenu();
        };
    }, [originLayers]);
};
